import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import Dashboard from './../components/Menu/Dashboard'
import PropTypes from 'prop-types';
//import LoadingScreen from '../components/Complements/LoadingScreen';
import { Grid, Typography } from '@material-ui/core';
//import { isMobile } from 'react-device-detect';
import Button from '@material-ui/core/Button';

//import Title from './../components/Complements/Title';
//import Footer from '../components/Complements/Footer';
import { history } from '../helpers/history';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

class PaymentOptionsContainer extends Component {

  renderAllBody = (items) => {
    return <Grid container spacing={2} alignItems='center' /* style={{height:'100%'}} */>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Typography
          //fullWidth

          style={{
            fontSize: '12px',
            /* color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757", */
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Escoge la categoría que deseas pagar:</Typography>
      </Grid>
      {items.map(i => {
        return <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center' key={i.url}>
          <Button
            fullWidth
            variant="contained"
            onClick={() => history.push(i.url)}
            style={{
              fontSize: '12px',
              color: '#ffffff',
              //borderRadius: '4px',
              '&:hover': {
                backgroundColor: "#706D85",
              },
              backgroundColor: "#2E2757",
              //fontFamily: 'MyriadPro-Bold',
              //padding: "20px",
              //border: '2px solid #BEBCC0',
              //
              borderRadius: "8px",
              boxShadow: '1px 4px 12px 0px rgba(46,46,46,0.75)'
            }}
          >
            <Grid item xs={10} container justifyContent='flex-start'>{i.text.substring(19)}</Grid>
            <Grid item xs={2} container justifyContent='flex-end'><ChevronRightIcon /></Grid>
          </Button>
        </Grid>
      })}
      {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/water-payment')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Agua</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/electricity-payment')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Luz</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/telephone-payment')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Telefonía fija</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/internet')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Internet</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/electronic-recharges')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Recargas</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/plan-payment')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Planes</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/catalog-payment')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Catalogo de revistas</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/iess')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >IESS</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/sri')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >SRI</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/judiciary-council')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Consejo de Judicatura</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/transit')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Transito</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/municipalities')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Municipio</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/others')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Varios</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/shops')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Comercios</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          //fullWidth
          variant="contained"
          onClick={() => history.push('/cards')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
              backgroundColor: "#a7a8a8",
            },
            '&:hover': {
              backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
          }}
        >Tarjetas</Button>
      </Grid> */}
      {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {(isMobile) ? renderChart : renderInfoBody}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {(isMobile) ? <></> : renderChart}
            </Grid> */}
    </Grid>
  }

  render() {
    const { menuItems/* , loading */ } = this.props
    // console.log('menuItems', menuItems)
    let subMenuItems = menuItems.map(i => {
      return (i.text === 'Pago de servicios') ? i.application_submenu : ''
    })
    // console.log(subMenuItems[3])
    /* if (menuItems[i].text === 'Pago de servicios') {
      // console.log(menuItems[i].application_submenu)
    } */
    return (
      <div /* style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo.png'})`,
        backgroundSize: "100% 100vh",
        width: "100%",
        //height : "100vh",
        minWidth: "100%",
        minHeight: "100vh",
        backgroundRepeat: "repeat-y",
        top: "0"
      }} */>
        <Dashboard
          title="Dashboard"
          body={this.renderAllBody(subMenuItems[3])}
          multiple={false}
        />
        {/* <LoadingScreen open={!loading} /> */}
        {/* <Footer /> */}
      </div>
    );
  }
}

PaymentOptionsContainer.propTypes = {
  user: PropTypes.object,
}

export default withRouter(PaymentOptionsContainer);